'use client';

import React from 'react';
import { CanLogoIcon } from '@/../public/assets/icons';
import { Box, Text } from '@chakra-ui/react';
import 'react-phone-input-2/lib/style.css';
import { TClinicDetailsProps } from './types/template.types';
import SpecializationForm from '../../forms/clinic/SpecializationForm/SpecializationForm';

const Specialization = ({ next, details, previous }: TClinicDetailsProps) => {
   return (
      <>
         <Box minH="72px">
            <CanLogoIcon />
         </Box>
         <Text
            as="h2"
            color="white"
            fontSize={{ base: '4xl', sm: '5xl', md: '12xl' }}
            fontWeight="bold"
            textAlign="center"
         >
            Specialisation
         </Text>
         <Text color="white" textStyle="md" textAlign="center" mt="-10px" mb="2">
            Please enter your personal details.
            <br /> Your data is secure.
         </Text>
         <SpecializationForm next={next} details={details} previous={previous} />
      </>
   );
};

export default Specialization;
